export class AppointmentHubAccordion extends DrupalBehavior {
  onReady(context) {
    const accordionTitles = once(
      'accordion-title',
      '.appointment-hub--accordion-section .section--title',
      context
    );
    let $accordion = $(accordionTitles[0]).parent();
    $accordion.addClass('open');

    accordionTitles.forEach((title) => {
      title.addEventListener('click', function (e) {
        e.preventDefault();
        $('.appointment-hub--accordion-section').removeClass('open');
        const $accordion = $(this).parent();
        $accordion.toggleClass('open');
      });
    });
  }
}

DrupalBehavior.register(
  'rush_theme.components',
  'appointment_hub_accordion',
  AppointmentHubAccordion
);
